<template>
  <section class="HomeRecommendSpecial">
    <HeadingLv2 text="スペシャルコンテンツ" icon="idea" />

    <div class="wrapper">
      <div class="list">
        <div v-for="content in displayContents" :key="content.id" class="card">
          <HomeRecommendSpecialCard
            :heading="cropText(content.title)"
            :category="content.category"
            :image="content.imageUrl"
            :imageAlt="content.imageAlt"
            :path="content.path"
            :url="content.externalLinkUrl"
            :showPr="content.isPr"
          />
        </div>
      </div>
    </div>

    <Button
      href="/magazines/special"
      :handleClick="moveToSpecialIndex"
      label="スペシャルコンテンツ一覧へ"
      primary
    />
  </section>
</template>

<script lang="ts">
import { defineComponent, computed, PropType } from 'vue'
import { useRouter } from 'vue-router'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import Button from '@/components/elements/Button.vue'
import HomeRecommendSpecialCard from '@/components/block/HomeRecommendSpecialCard.vue'
import type { MagazineSpecialRecommendContent } from '@/types/MagazineRecommend'

export default defineComponent({
  name: 'HomeRecommendSpecial',

  components: {
    HomeRecommendSpecialCard,
    HeadingLv2,
    Button
  },

  props: {
    contents: {
      type: Array as PropType<MagazineSpecialRecommendContent[]>,
      default: () => []
    }
  },

  setup(props) {
    const router = useRouter()
    const displayContents = computed(() => props.contents.slice(0, 12))

    const cropText = (text: string) => {
      return text.length > 30 ? text.substr(0, 30) + '…' : text
    }

    const moveToSpecialIndex = () => {
      router.push(`/magazines/special`)
    }

    return {
      displayContents,
      cropText,
      moveToSpecialIndex
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.wrapper {
  overflow: hidden;
  margin-bottom: 30px;
}

.list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;

  @include mixins.mediaMax('sm') {
    margin-right: -20px;
  }

  @include mixins.media('sm') {
    margin-right: -24px;
  }

  @include mixins.media() {
    margin-right: -36px;
  }
}

.card {
  line-height: 1.78;

  @include mixins.mediaMax('sm') {
    flex: 0 0 calc((100% - 40px) / 2);
    margin-right: 20px;
    margin-bottom: 20px;
  }

  @include mixins.media('sm') {
    flex: 0 0 calc((100% - 72px) / 3);
    margin-right: 24px;
    margin-bottom: 24px;
  }

  @include mixins.media() {
    flex: 0 0 calc((100% - 144px) / 4);
    margin-right: 36px;
    margin-bottom: 36px;
  }
}
</style>
